module.exports = __webpack_public_path__ + "img/heart-circled.9ffe18a9.svg";